import { parseJiraLinkFormats } from "components/MarkupFormatter";

import { ACModalV2Placement } from "ac-components/ac-modal/ACModalV2";

export const FindingModalCommonConfig = {
  width: 1024,
  mask: true,
  settingsPrefixKey: "finding-details",
  defaultPlacement: "right" as ACModalV2Placement,
  resize: true,
};

export const convertCommentToNewFormat = (comment: string) => {
  // This converts finding id to link
  comment = parseJiraLinkFormats(comment);
  if (!comment.includes("mention") && !comment.includes("ql-attachment")) {
    return comment;
  }
  const div = document.createElement("div");
  div.innerHTML = comment;

  const mentionElements = div.querySelectorAll(
    ".mention",
  ) as NodeListOf<HTMLElement>;
  mentionElements.forEach((element) => {
    element.setAttribute("data-type", "mention");
    element.setAttribute("data-label", element.innerHTML.slice(1));
  });

  const attachmentElements = div.querySelectorAll(
    ".ql-attachment",
  ) as NodeListOf<HTMLElement>;
  attachmentElements.forEach((element) => {
    const src = element.getAttribute("data-url") as string;
    const name = element.getAttribute("data-name") as string;

    const file = document.createElement("file-attachment");
    file.setAttribute("src", src);
    file.setAttribute("name", name);

    (element.parentNode as HTMLElement).replaceChild(file, element);
  });
  return div.innerHTML;
};
